



















































































































































import { Component, Prop, PropSync, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';

import { Country, LegalStatus } from '@/proxy/Prequalification.CandidateMgt.FacadeClient';
import { FieldRules, FormRegister } from '@/types';
import { mutationTypes as referenceDataMutationTypes } from '@/store/module/referenceData/mutations';
import { actionTypes as referenceDataActionTypes } from '@/store/module/referenceData/actions';

const referenceData = namespace('referenceData');

@Component({})
export default class RegisterFormCompany extends Vue {
  @PropSync('registerForm', { type: Object, required: true })
  registerFormSync!: FormRegister;

  @PropSync('isValid', { type: Boolean, required: true })
  isValidSync!: boolean;

  @Prop({ type: Object, required: true })
  readonly rules!: FieldRules;

  @referenceData.State(state => state.countryId)
  readonly countryId: string | undefined;

  @referenceData.State(state => state.countries)
  readonly countries!: Country[];

  @referenceData.State(state => state.legalStatuses)
  readonly legalStatuses!: LegalStatus[];

  @referenceData.Mutation(referenceDataMutationTypes.setCountryId)
  setCountryId!: (value: string | undefined) => void;

  @referenceData.Action(referenceDataActionTypes.fetchLegalStatuses)
  fetchLegalStatuses!: () => void;

  get isNaturalPerson(): boolean {
    return this.registerFormSync.candidate.legalStatus === "PP";
  }

  onSelectCountry(value: string) {
    if (value === this.countryId) {
      return;
    }

    this.setCountryId(value);
    this.fetchLegalStatuses();
  }
};
